/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_preliminary_florida_finance_disclosure_document.proto at 9:1
 */
export const RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest');
fixType(RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrievePreliminaryFloridaFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_preliminary_florida_finance_disclosure_document.proto at 15:1
 */
export const RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse');
fixType(RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrievePreliminaryFloridaFinanceDisclosureDocumentResponse);